import { createSlice } from "@reduxjs/toolkit";

import { getPriceListApi, getPriceListCountApi } from "../../reduxApi/admin/PriceListReduxApi";
const PriceListSlice = createSlice({
  name: "PriceList",
  initialState: {
    getPriceList: [],
    getPriceListCount: [],
    status: "idle",
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getPriceListApi.fulfilled, (state, action) => {
      state.status = "fulfilled";
      // console.log("getMappingList action", action.payload);
      state.getPriceList = action.payload.data;
      // console.log("getMappingList", state.getMappingList);
    });

    builder.addCase(getPriceListCountApi.fulfilled, (state, action) => {
      state.status = "fulfilled";
      // console.log("getMappingList action", action.payload);
      state.getPriceListCount = action.payload.data;
      // console.log("getMappingList", state.getMappingList);
    });
  },
});
// export const { deleteOrdersAction, updateOrdersAction, addOrdersAction } = OrdersSlice.actions
export default PriceListSlice.reducer;
